import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import { useUser } from "../../context/userContext";
import menuData from "./menuData";
import logo from "../../assets/images/logo/logo_rmbg.png";
import { ReactComponent as Buldge } from "../../assets/icons/buldge_icon.svg";
import { ReactComponent as UserIcon } from "../../assets/icons/profile_icon.svg";
import { ReactComponent as PasswordIcon } from "../../assets/icons/password_icon.svg";
import { ReactComponent as LogoutIcon } from "../../assets/icons/logout_icon.svg";
import ProfileModal from "../ProfileModal/profileModal.component";
import PasswordModal from "../PasswordModal/passwordModal.component";
import MobileNavBar from "./mobileNavBar";

const NavBar = () => {
  // const sessionToken = Cookies.get('sessionToken');
  const { userData, setUserData } = useUser();

  const [initials, setInitials] = useState("");

  useEffect(() => {
    if (userData?.first_name) {
      setInitials(userData.first_name.charAt(0).toUpperCase());
    }
  }, [userData]);

  const navigate = useNavigate();

  // Sticky Navbar
  const [sticky, setSticky] = useState(false);
  const handleStickyNavbar = () => {
    if (window.scrollY >= 80) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleStickyNavbar);
  });

  const [isMenuModalOpen, setIsMenuModalOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const handleProfileOpen = () => {
    setIsMenuModalOpen(!isMenuModalOpen);
    setIsProfileModalOpen(!isProfileModalOpen);
  };

  const handleProfileClose = () => {
    setIsProfileModalOpen(!isProfileModalOpen);
  };

  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const handlePasswordModalOpen = () => {
    setIsMenuModalOpen(!isMenuModalOpen);
    setIsPasswordModalOpen(!isPasswordModalOpen);
  };

  const handlePasswordModalClose = () => {
    setIsPasswordModalOpen(!isPasswordModalOpen);
  };

  useEffect(() => {
    if (isMenuModalOpen) {
      // Disable scrolling when modal is open
      document.body.style.overflow = "hidden";
    } else {
      // Restore scrolling when modal is closed
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMenuModalOpen]);

  const handleSignOut = () => {
    Cookies.remove('sessionToken');
    setUserData(null);
    localStorage.removeItem('userData');
    navigate("/signin");
    navigate(0);
  };

  return (
    <>
      <MobileNavBar />

      <header
        className={`header top-0 left-0 z-40 flex w-full items-center bg-transparent ${
          sticky
            ? "!fixed !z-[40] !bg-white !bg-opacity-80 shadow-sticky backdrop-blur-sm !transition"
            : "absolute"
        }`}
      >
        <div className="container">
          <div className="hidden lg:flex items-center justify-between">
            <div className="flex items-center">
              
              {/* Company Logo */}
              <div className="md:w-48 lg:w-60 max-w-full px-4 lg:mr-12">
                <Link
                  to="/"
                  className={`header-logo block w-full ${
                    sticky ? "py-5 lg:py-2" : "py-8"
                  } `}
                >
                  <img src={logo} alt="logo" className="w-full" />
                </Link>
              </div>

              {/* Navigation Options */}
                <ul className="flex">
                  {menuData.map(
                    (menuItem, index) =>
                      (menuItem.id !== 6 || userData?.email) && (
                        <li key={menuItem.id} className="md:px-3 lg:px-4">
                          <Link
                            to={menuItem.path}
                            className={`flex py-2 text-base text-dark group-hover:opacity-70 dark:text-white lg:mr-0 lg:inline-flex lg:py-6 lg:px-0`}
                            onClick={() => window.scrollTo({top: 0})}
                          >
                            {menuItem.title}
                          </Link>
                        </li>
                      )
                  )}
                </ul>

            </div>
            <div className="flex items-center justify-end min-w-fit">
              {userData?.email ? (
                <div
                  className="relative ml-2 cursor-pointer"
                  title="Account"
                  onClick={() => setIsMenuModalOpen(!isMenuModalOpen)}
                >
                  <span className="flex items-center justify-center w-7 h-7 border-2 border-black rounded-full bg-neutral-100 text-black">
                    {initials}
                  </span>
                  {isMenuModalOpen && userData && (
                    <div
                      className={`absolute top-[150%] right-[-30px] flex items-center justify-center drop-shadow-[0_4px_24px_rgba(0,0,0,0.24)] z-50`}
                    >
                      <div className="relative bg-white p-4 rounded-md">
                        <Buldge className="absolute top-[-10px] right-7" />
                        <div className="flex items-center">
                          <span className="flex items-center justify-center w-14 h-14 text-black text-xl border border-neutral-100 rounded-full bg-neutral-100">
                            {initials}
                          </span>
                          <div className="ml-2">
                            <p className="font-medium tracking-tight">
                              {userData.first_name + " " + userData.last_name}
                            </p>
                            <p className="text-gray-500 text-xs">
                              {userData.email}
                            </p>
                          </div>
                        </div>

                        <div className="mt-3 border border-neutral-100" />
                        <div className="mt-4 mx-2">
                          <div
                            className="flex items-center mt-2 cursor-pointer"
                            onClick={handleProfileOpen}
                          >
                            <UserIcon />
                            <p className="ml-3 text-neutral-500 hover:text-neutral-800 hover:font-medium">
                              View Profile
                            </p>
                          </div>
                          <div
                            className="flex items-center mt-2 cursor-pointer"
                            onClick={handlePasswordModalOpen}
                          >
                            <PasswordIcon />
                            <p className="ml-3 text-neutral-500 hover:text-neutral-800 hover:font-medium">
                              Change Password
                            </p>
                          </div>
                          <div
                            className="flex items-center mt-2 cursor-pointer"
                            onClick={handleSignOut}
                          >
                            <LogoutIcon />
                            <p className="ml-3 text-neutral-500 hover:text-neutral-800 hover:font-medium">
                              Log Out
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <Link
                    to="/signin"
                    className="py-3 px-7 text-base font-bold text-dark hover:opacity-70 dark:text-white"
                  >
                    Sign In
                  </Link>
                  <Link
                    to="/signup"
                    className="rounded-md bg-primary py-3 px-8 text-base font-bold text-white transition duration-300 hover:bg-opacity-90 hover:shadow-signUp md:px-9 lg:px-6 xl:px-9"
                  >
                    Sign Up
                  </Link>{" "}
                </>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* User Profile Modal */}
      {isProfileModalOpen && userData && (
        <ProfileModal
          initials={initials}
          handleProfileClose={handleProfileClose}
        />
      )}

      {/* Change Password Modal */}
      {isPasswordModalOpen && userData && (
        <PasswordModal
          initials={initials}
          handlePasswordClose={handlePasswordModalClose}
        />
      )}
    </>
  );
};

export default NavBar;
